import { nexiCheckoutApi } from './checkout'

export const nexiApi = {
  checkout: nexiCheckoutApi
}
